// Migrated to Polaris Web Components
import React from 'react';
// export const errorModal= ({ bulkErrorActive, handleBulkErrorChangeModal,bulkErrors }) => (
//     <Modal
//       large
//       open={bulkErrorActive}
//       title="Failed products"
//       onClose={handleBulkErrorChangeModal}
//     >
//       {bulkErrors.map(({ handle, userErrors }, index) => (
//         <Modal.Section key={index}>
//           <VerticalStack gap="2">
//             {!handle ? (
//               <p>#{index + 1}&nbsp;Handle: {handle}</p>
//             ) : null}
//             {userErrors.map(({ message }, index) => (
//               <InlineError message={message} fieldID={index + 1} />
//             ))}
//           </VerticalStack>
//         </Modal.Section>
//       ))}
//     </Modal>
//   );

export const errorModal = ({ bulkErrors, currentRoute, heading }) => {

  const headingByRoute = {
    product: 'Failed products',
    products: 'Failed products',
    metaobject: 'Failed metaobjects',
    metaobjects: 'Failed metaobjects',
    definition: 'Failed definitions',
    definitions: 'Failed definitions',
    collection: 'Failed collections',
    collections: 'Failed collections',
    customer: 'Failed customers',
    customers: 'Failed customers',
    order: 'Failed orders',
    orders: 'Failed orders',
    translation: 'Failed translations',
    translations: 'Failed translations',
    menu: 'Failed menu items',
    menuitem: 'Failed menu items'
  };

  const modalHeading = heading || headingByRoute[(currentRoute || '').toLowerCase()] || 'Failed products';

  function displayHandle(handle) {
    const MAX_DISPLAY_LENGTH = 100;
    if (handle?.length > MAX_DISPLAY_LENGTH) {
      const truncatedHeaders = handle?.slice(0, MAX_DISPLAY_LENGTH) + ' ...';
      return truncatedHeaders;
    }
    return handle;
  }
  
  const productErrors = [];
  bulkErrors?.forEach(({ handle, userErrors }) => {
    userErrors?.forEach((userError) => {
      const { message, fieldName, fieldValue } = userError;
      productErrors.push({
        handle: handle,
        error: message,
        fieldName: fieldName || '-',
        fieldValue: fieldValue || '-',
      });
    });
  });

  return (
    <s-modal id="bulk-error-modal" heading={modalHeading} size="large" padding="none">
      <s-box padding="none">
        <s-table>
          <s-table-header-row>
            <s-table-header>#</s-table-header>
            <s-table-header>Handle</s-table-header>
            <s-table-header>Field</s-table-header>
            <s-table-header>Value</s-table-header>
            <s-table-header>Error</s-table-header>
          </s-table-header-row>
          <s-table-body>
            {productErrors.map((error, index) => (
              <React.Fragment key={index}>
                <s-tooltip id={`handle-tooltip-${index}`}>{error.handle}</s-tooltip>
                <s-tooltip id={`field-tooltip-${index}`}>{error.fieldName}</s-tooltip>
                <s-tooltip id={`value-tooltip-${index}`}>{error.fieldValue}</s-tooltip>
                <s-tooltip id={`error-tooltip-${index}`}>{error.error}</s-tooltip>
                <s-table-row>
                  <s-table-cell>{index + 1}</s-table-cell>
                  <s-table-cell>
                    <s-text type="strong" interestFor={error.handle?.length > 100 ? `handle-tooltip-${index}` : undefined}>
                      {displayHandle(error.handle)}
                    </s-text>
                  </s-table-cell>
                  <s-table-cell>
                    <s-text interestFor={error.fieldName?.length > 100 ? `field-tooltip-${index}` : undefined}>
                      {error.fieldName}
                    </s-text>
                  </s-table-cell>
                  <s-table-cell>
                    <s-text interestFor={error.fieldValue?.length > 100 ? `value-tooltip-${index}` : undefined}>
                      {error.fieldValue}
                    </s-text>
                  </s-table-cell>
                  <s-table-cell>
                    <s-text tone="critical" interestFor={`error-tooltip-${index}`}>
                      {error.error}
                    </s-text>
                  </s-table-cell>
                </s-table-row>
              </React.Fragment>
            ))}
          </s-table-body>
        </s-table>
      </s-box>
      <s-button 
        slot="primary-action"
        commandFor="bulk-error-modal"
        command="--hide"
      >
        Close
      </s-button>
    </s-modal>
  );
};


export const WarningModal = ({ uploadWarnings, loading }) => {
  
  return (
    <s-modal id="upload-warnings-modal" heading="Products not uploaded" size="large">
      <s-box padding="large">
        <s-table>
          <s-table-header-row>
            <s-table-header>#</s-table-header>
            <s-table-header>Error</s-table-header>
          </s-table-header-row>
          <s-table-body>
            {uploadWarnings?.map((error, index) => (
              <s-table-row key={index}>
                <s-table-cell>{index + 1}</s-table-cell>
                <s-table-cell>
                  <s-text type="strong">
                    {error}
                  </s-text>
                </s-table-cell>
              </s-table-row>
            ))}
          </s-table-body>
        </s-table>
      </s-box>
      <s-button 
        slot="primary-action"
        commandFor="upload-warnings-modal"
        command="--hide"
      >
        Close
      </s-button>
    </s-modal>
  );
};


  export const errorMetaModal = ({ bulkMetaErrors }) => {
    
    const metafieldErrors = [];
    bulkMetaErrors?.forEach(({ metafields, userErrors }, index) => {
      if (metafields !== undefined) {
        metafields?.forEach((metafield, metaIndex) => {
          if (userErrors[metaIndex]) {
            const { key, namespace, type, value, resource, handle } = metafield;
            const { message } = userErrors[metaIndex];
            metafieldErrors.push({
              id: `${index}-${metaIndex}`,
              handle: handle,
              key: key,
              namespace: namespace,
              value: value,
              type: type,
              error: message,
              resource: resource,
            });
          }
        });
      } else {
        userErrors?.forEach((userError, metaIndex) => {
          const { message } = userError;
          metafieldErrors.push({
            id: `${index}-${metaIndex}`,
            error: message,
          });
        });
      }
    });
  
    return (
      <s-modal id="bulk-meta-error-modal" heading="Failed metafields" size="large">
        <s-table padding="none">
          <s-table-header-row>
            <s-table-header>Handle</s-table-header>
            <s-table-header>Resource</s-table-header>
            <s-table-header>Namespace</s-table-header>
            <s-table-header>Key</s-table-header>
            <s-table-header>Value</s-table-header>
            <s-table-header>Error</s-table-header>
          </s-table-header-row>
          <s-table-body>
            {metafieldErrors.map(({ id, handle, resource, key, namespace, value, error }) => (
              <s-table-row key={id}>
                <s-table-cell>
                  <s-text type="strong" interestFor={handle?.length > 50 ? `meta-handle-${id}` : undefined}>
                    {handle?.length > 50 ? handle.substring(0, 50) + '...' : handle}
                  </s-text>
                  {handle?.length > 50 && (
                    <s-tooltip id={`meta-handle-${id}`}>{handle}</s-tooltip>
                  )}
                </s-table-cell>
                <s-table-cell>
                  <s-text interestFor={resource?.length > 30 ? `meta-resource-${id}` : undefined}>
                    {resource?.length > 30 ? resource.substring(0, 30) + '...' : resource}
                  </s-text>
                  {resource?.length > 30 && (
                    <s-tooltip id={`meta-resource-${id}`}>{resource}</s-tooltip>
                  )}
                </s-table-cell>
                <s-table-cell>
                  <s-text interestFor={namespace?.length > 30 ? `meta-namespace-${id}` : undefined}>
                    {namespace?.length > 30 ? namespace.substring(0, 30) + '...' : namespace}
                  </s-text>
                  {namespace?.length > 30 && (
                    <s-tooltip id={`meta-namespace-${id}`}>{namespace}</s-tooltip>
                  )}
                </s-table-cell>
                <s-table-cell>
                  <s-text interestFor={key?.length > 30 ? `meta-key-${id}` : undefined}>
                    {key?.length > 30 ? key.substring(0, 30) + '...' : key}
                  </s-text>
                  {key?.length > 30 && (
                    <s-tooltip id={`meta-key-${id}`}>{key}</s-tooltip>
                  )}
                </s-table-cell>
                <s-table-cell>
                  <s-text interestFor={value?.length > 40 ? `meta-value-${id}` : undefined}>
                    {value?.length > 40 ? value.substring(0, 40) + '...' : value}
                  </s-text>
                  {value?.length > 40 && (
                    <s-tooltip id={`meta-value-${id}`}>{value}</s-tooltip>
                  )}
                </s-table-cell>
                <s-table-cell>
                  <s-text tone="critical" interestFor={error?.length > 80 ? `meta-error-${id}` : undefined}>
                    {error?.length > 80 ? error.substring(0, 80) + '...' : error}
                  </s-text>
                  {error?.length > 80 && (
                    <s-tooltip id={`meta-error-${id}`}>{error}</s-tooltip>
                  )}
                </s-table-cell>
              </s-table-row>
            ))}
          </s-table-body>
        </s-table>
        <s-button 
          slot="primary-action"
          commandFor="bulk-meta-error-modal"
          command="--hide"
        >
          Close
        </s-button>
      </s-modal>
    );
  };


  export const combinedErrorModal = ({ bulkErrors, bulkMetaErrors }) => {
    
    const truncateText = (text, maxLength) => {
      if (!text || text === '-') return text;
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    };
    
    const allErrors = [];
    bulkErrors?.forEach(({ handle, userErrors, email }) => {
      userErrors?.forEach((userError) => {
        const { message } = userError;
        allErrors.push({
          type: 'Customer',
          handle: email || '-',
          namespace: '-',
          key: '-',
          value: '-',
          error: message,
        });
      });
    });

    bulkMetaErrors?.forEach(({ metafields, userErrors }, index) => {
      if (metafields !== undefined) {
        metafields?.forEach((metafield, metaIndex) => {
          if (userErrors[metaIndex]) {
            const { key, namespace, value, handle } = metafield;
            const { message } = userErrors[metaIndex];
            allErrors.push({
              type: 'Metafield',
              handle: handle || '-',
              namespace: namespace || '-',
              key: key || '-',
              value: value || '-',
              error: message,
            });
          }
        });
      } else {
        userErrors?.forEach((userError) => {
          const { message } = userError;
          allErrors.push({
            type: 'Metafield',
            handle: '-',
            namespace: '-',
            key: '-',
            value: '-',
            error: message,
          });
        });
      }
    });

    return (
      <s-modal id="combined-error-modal" heading="Failed Customers" size="large">
        <s-box padding="large">
          <s-table>
            <s-table-header-row>
              <s-table-header>#</s-table-header>
              <s-table-header>Type</s-table-header>
              <s-table-header>Email</s-table-header>
              <s-table-header>Namespace</s-table-header>
              <s-table-header>Key</s-table-header>
              <s-table-header>Value</s-table-header>
              <s-table-header>Error</s-table-header>
            </s-table-header-row>
            <s-table-body>
              {allErrors.map(({ type, handle, namespace, key, value, error }, index) => (
                <s-table-row key={index}>
                  <s-table-cell>{index + 1}</s-table-cell>
                  <s-table-cell>
                    <s-badge tone={type === 'Customer' ? 'critical' : 'warning'}>{type}</s-badge>
                  </s-table-cell>
                  <s-table-cell>
                    <s-text type="strong" interestFor={handle?.length > 50 ? `combined-handle-${index}` : undefined}>
                      {truncateText(handle, 50)}
                    </s-text>
                    {handle?.length > 50 && (
                      <s-tooltip id={`combined-handle-${index}`}>{handle}</s-tooltip>
                    )}
                  </s-table-cell>
                  <s-table-cell>
                    <s-text interestFor={namespace !== '-' && namespace?.length > 30 ? `combined-namespace-${index}` : undefined}>
                      {truncateText(namespace, 30)}
                    </s-text>
                    {namespace !== '-' && namespace?.length > 30 && (
                      <s-tooltip id={`combined-namespace-${index}`}>{namespace}</s-tooltip>
                    )}
                  </s-table-cell>
                  <s-table-cell>
                    <s-text interestFor={key !== '-' && key?.length > 30 ? `combined-key-${index}` : undefined}>
                      {truncateText(key, 30)}
                    </s-text>
                    {key !== '-' && key?.length > 30 && (
                      <s-tooltip id={`combined-key-${index}`}>{key}</s-tooltip>
                    )}
                  </s-table-cell>
                  <s-table-cell>
                    <s-text interestFor={value !== '-' && value?.length > 40 ? `combined-value-${index}` : undefined}>
                      {truncateText(value, 40)}
                    </s-text>
                    {value !== '-' && value?.length > 40 && (
                      <s-tooltip id={`combined-value-${index}`}>{value}</s-tooltip>
                    )}
                  </s-table-cell>
                  <s-table-cell>
                    <s-text tone="critical" interestFor={error?.length > 80 ? `combined-error-${index}` : undefined}>
                      {truncateText(error, 80)}
                    </s-text>
                    {error?.length > 80 && (
                      <s-tooltip id={`combined-error-${index}`}>{error}</s-tooltip>
                    )}
                  </s-table-cell>
                </s-table-row>
              ))}
            </s-table-body>
          </s-table>
        </s-box>
        
        <s-button 
          slot="primary-action"
          commandFor="combined-error-modal"
          command="--hide"
        >
          Close
        </s-button>
      </s-modal>
    );
  };